

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_yfwqmx2lfy = () => {
                    
                        if (document.querySelector('.beae-il5fp32l:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-il5fp32l:not([data-beae-bind])'),
                                
                                id: 'beae-il5fp32l',
                                isLive: true
                            });
                            document.querySelector('.beae-il5fp32l:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-nz2e8069:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-nz2e8069:not([data-beae-bind])'),
                                
                                id: 'beae-nz2e8069',
                                isLive: true
                            });
                            document.querySelector('.beae-nz2e8069:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-mbkmg2be:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-mbkmg2be:not([data-beae-bind])'),
                                
                                id: 'beae-mbkmg2be',
                                isLive: true
                            });
                            document.querySelector('.beae-mbkmg2be:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_yfwqmx2lfy()
                } else {
                    window.beaePageJS.push(jsHandle_yfwqmx2lfy)
                }
            